import { Component, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { Dialog, DialogRef } from '../../../dialog.base';

@Component({
  selector: 'uex-dialog-footer',
  templateUrl: './footer.component.html',
  host: {
    class: 'uex-dialog-footer modal-footer'
  }
})
export class DialogFooterComponent implements AfterViewInit, OnDestroy {
  @Input('alignItems') public alignItems: string = 'center';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  constructor(
    private _dialogRef: DialogRef,
    public elementRef: ElementRef
  ) { }

  private _dialog: Dialog;
  private _index: number;

  public ngAfterViewInit() {
    this._dialog = this._dialogRef.dialog;
    this._index = this._dialog.addFooter(this);
  }

  public ngOnDestroy() {
    this._dialog.removeFooter(this._index);
  }
}
